import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { GeneralService } from '../services/general.service';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  const refreshToken = localStorage.getItem('refreshToken');

  checkTokenExpiration();

  if (token === null) {
    // 1. Obtenemos la ruta real del navegador (más rápido y seguro que el Router al inicio)
    const currentPath = window.location.pathname;

    // 2. Definimos en qué rutas el interceptor NO debe expulsar al usuario
    const isPublicRoute =
      currentPath.includes('/login') ||
      currentPath.includes('/external-access') ||
      currentPath.includes('/changePassword'); 

    // 3. Solo cerramos sesión si está intentando entrar a una ruta privada sin token
    if (!isPublicRoute) {
      const authService = inject(AuthService);
      authService.logout();
    }

    return next(req);
  } else {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        Refreshtoken: `${refreshToken}`,
      },
    });
    return next(cloned);
  }
};

const checkTokenExpiration = (): void => {
  const tokenExpiryStr = localStorage.getItem('accessTokenExpiresAtUtc');
  if (!tokenExpiryStr) return;

  const generalService = inject(GeneralService);
  const authService = inject(AuthService);

  // 1. Hora de expiración que mandó el servidor (ya es el futuro)
  const expiryTimeMs = Date.parse(tokenExpiryStr);
  if (isNaN(expiryTimeMs)) {
    authService.logout();
    return;
  }

  // 2. Hora actual real
  const nowMs = Date.now();

  // 3. Lógica simple: ¿Ya es más tarde de la hora de morir?
  if (nowMs >= expiryTimeMs) {
    generalService.viewSnacAlert('Inicio de sesión requerido', 'alert', 'Sesión expirada');
    authService.logout();
  }
};
